import { render, staticRenderFns } from "./OptimizerIconV2.ts.vue?vue&type=template&id=5fb539d4"
import script from "./OptimizerIconV2.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptimizerIconV2.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OptimizerIconV2.ts.vue?vue&type=style&index=0&id=5fb539d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports